<template>
  <!-- Remplacer dans le futur les templates par des sous-composants et un composant dynamique (:is) -->
  <v-card width="100%" elevation="0">
    <v-container v-if="type == 'msg'">
      <v-row justify="center">
        <v-col class="px-0 d-flex justify-center">
          <v-skeleton-loader class="edn-skeleton-avatar" type="avatar"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row v-for="(row,id) in arrDimension" :key="id">
        <v-col class="py-2">
          <v-skeleton-loader :height="row.height" class="mx-auto" :width="row.width" type="image"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col
          :key="id"
          class="px-0 d-flex justify-center py-2"
          cols="1"
          height="80px"
          width="50px"
          v-for="(skeleton, id) in 3"
        >
          <v-skeleton-loader type="avatar"></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else-if="type == 'page'" fluid>
      <v-row>
        <v-col>
          <v-card class="pa-4">
            <v-skeleton-loader class="py-3" type="list-item-avatar"></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" class="d-flex flex-column">
          <v-card class="pa-4">
            <v-skeleton-loader v-for="n in 6" :key="n" type="image" height="25px" class="my-3"></v-skeleton-loader>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card class="pa-4">
            <skeleton-field type="field" v-for="(skeleton,id) in 8" :key="id"></skeleton-field>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card class="pa-4">
            <v-skeleton-loader type="article"></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <skeleton-field type="field" v-else-if="type == 'field'" /> 
  </v-card>
</template>

<script>
export default {
  name:"ednSkeletonTemplate",
  props: {
    type: {
      type: String,
      default: ()=>{}
    }
  },
  data() {
    return {
      arrDimension: [
        {height:'50px',width:'350px'},
        {height:'25px',width:'250px'},
        {height:'25px',width:'70px'},
        ]
    }
  },
}
</script>

<style lang="scss">
.edn-skeleton-avatar .v-skeleton-loader__avatar {
  height: 90px;
  width: 90px;
}
</style>
